(function(){
  'use strict';
  function ensureCartIcon(){
    var right=document.querySelector('.logo-area__right__inner');
    if(!right)return;
    if(right.querySelector('.cart-link'))return;
    var a=document.createElement('a');
    a.href='/cart';
    a.className='cart-link';
    a.setAttribute('aria-label','Cart');
    a.innerHTML='<span class="cart-link__label visually-hidden">Cart</span>'
      +'<span class="cart-link__icon">'
      +'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">'
      +'<path d="M16.5456 13C17.2956 13 17.9656 12.59 18.2956 11.97L21.8756 5.48C22.2456 4.82 21.7656 4 21.0056 4H6.20562L5.26562 2H2.00562V4H4.00562L7.60562 11.59L6.24562 14.03C5.51562 15.37 6.47562 17 8.00562 17H20.0056V15H8.00562L9.10562 13H16.5456ZM7.15562 6H19.3056L16.5456 11H9.52562L7.15562 6ZM8.00562 18C6.90562 18 6.01562 18.9 6.01562 20C6.01562 21.1 6.90562 22 8.00562 22C9.10562 22 10.0056 21.1 10.0056 20C10.0056 18.9 9.10562 18 8.00562 18ZM18.0056 18C16.9056 18 16.0156 18.9 16.0156 20C16.0156 21.1 16.9056 22 18.0056 22C19.1056 22 20.0056 21.1 20.0056 20C20.0056 18.9 19.1056 18 18.0056 18Z" fill="currentColor"/>'
      +'</svg>'
      +'<span class="cart-link__count"></span>'
      +'</span>';
    right.appendChild(a);
    var drawer=document.querySelector('.js-cart-drawer');
    if(drawer){
      a.addEventListener('click',function(e){
        e.preventDefault();
        drawer.open(e.target);
      });
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',ensureCartIcon);
  }else{
    ensureCartIcon();
  }
  var obs=new MutationObserver(function(){ensureCartIcon()});
  var target=document.querySelector('.logo-area__right__inner');
  if(target)obs.observe(target,{childList:true});
})();